import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  inputLabel?: string
  brand: 'toyota' | 'lexus'
}

const CommunicationsPreferences = ({ inputLabel, brand, ...rest }: Props) => {
  const label = inputLabel || `Communications Preferences`

  return (
    <div className="mb-4 md:mb-2" data-gt-name="componentevent">
      <div>
        <h3 className={`text-l md:text-xl lg:text-2xl mb-3 !leading-snug`}>
          {label}
        </h3>
        <p className="text-tiny mb-4">
          Please select your communications options:
        </p>

        <div>
          <div className="mb-4">
            <p className="text-tiny leading-snug">
              Would you like to receive updates about new products, services,
              and offers from {brand === 'toyota' ? 'Toyota' : 'Lexus'}{' '}
              Financial Services?
            </p>
          </div>

          <div className="radio-btn-container flex">
            <RadioButton
              errorDisabled
              name="communication_relevantoffers"
              label="Yes"
              value={true}
              {...rest}
            />
            <RadioButton
              errorDisabled
              name="communication_relevantoffers"
              label="No"
              value={false}
              {...rest}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommunicationsPreferences
